import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Check if it's a ResizeObserver error
      const isResizeObserverError = this.state.error?.message?.includes('ResizeObserver') ||
                                   this.state.error?.stack?.includes('ResizeObserver');
      
      if (isResizeObserverError) {
        return (
          <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <h3 className="text-yellow-800 font-semibold">Layout Issue Detected</h3>
            <p className="text-yellow-700 text-sm mt-1">
              The page layout is experiencing issues, but the application should continue to work normally.
            </p>
            <button 
              onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
              className="mt-2 px-3 py-1 bg-yellow-600 text-white rounded text-sm hover:bg-yellow-700"
            >
              Try Again
            </button>
          </div>
        );
      }

      // Generic error display
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <h3 className="text-red-800 font-semibold">Something went wrong</h3>
          <p className="text-red-700 text-sm mt-1">
            An error occurred while rendering this component.
          </p>
          <details className="mt-2">
            <summary className="cursor-pointer theme-primary text-sm">Error Details</summary>
            <pre className="mt-2 text-xs theme-primary bg-red-100 p-2 rounded overflow-auto">
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </pre>
          </details>
          <button 
            onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
            className="mt-2 px-3 py-1 bg-red-600 text-white rounded text-sm hover:theme-bg"
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
